import {useAxios} from '../hooks';

const usePedido = (tipoPedido = 'PEDIDO') => {

    

    const {getApiEmitirNotas} = useAxios();

    const novoPedido = async () => {
        const api = await getApiEmitirNotas();
        const result =  await api.post('/pedidos',{ tipoPedido });
        return result.data;
    }

    const vinculaCliente = async (pedido, cliente) => {
        const api = await getApiEmitirNotas();
        const result =  await api.post('/pedidos/' + pedido.id + '/cliente/' + cliente.uuid);
        return result.data;
    }

    const vinculaVendedor = async (pedido, cliente) => {
        const api = await getApiEmitirNotas();
        const result =  await api.post('/pedidos/' + pedido.id + '/vendedor/' + cliente.uuid);
        return result.data;
    }

    const desvinculaCliente = async (pedido) => {
        const api = await getApiEmitirNotas();
        const result =  await api.delete('/pedidos/' + pedido.id + '/cliente');
        return result.data;
    }

    const desvinculaVendedor = async (pedido) => {
        const api = await getApiEmitirNotas();
        const result =  await api.delete('/pedidos/' + pedido.id + '/vendedor');
        return result.data;
    }

    const addItemDb = async (pedido, item) => {
            const api = await getApiEmitirNotas();
            const result =  await api.post('/pedidos/' + pedido.id + '/item', item);
            return result.data;        
    }

    const atualizaPedido = async (pedido) => {
        const api = await getApiEmitirNotas();
        const result =  await api.post('/pedidos/' + pedido.id, pedido);
        return result.data;        
    }

    const removerItemDb = async (pedido, item) => {
        const api = await getApiEmitirNotas();

        const result =  await api.delete('/pedidos/' + pedido.id + '/itens', { data: [[item.id],item]});
        return result.data;        
    }

    const removerServicoDb = async(pedido,servico) => {
        const api = await getApiEmitirNotas();
        const result = await api.delete('/pedidos/' + pedido.uuid + '/servicos', { data: [[servico.uuid],servico] })
        return result.data;
    }

    const buscaPedido = async (idPedido) => {
        const api = await getApiEmitirNotas();

        const result =  await api.get('/pedidos/' + idPedido );
        return result.data;        
    }

    const separarEstoque = async (pedido) =>{
        const api = await getApiEmitirNotas();
        const result =  await api.post('/pedidos/' + pedido.id + "/estoque" );
        return result.data;        
    }

    const voltarEstoque = async (pedido) =>{
        const api = await getApiEmitirNotas();
        const result =  await api.delete('/pedidos/' + pedido.id + "/estoque" );
        return result.data;        
    }

    const emitirNFe = async (pedido) => {
        const api = await getApiEmitirNotas();
        const result =  await api.post('/pedidos/' + pedido.id + "/NFe" );
        
        return result.data;        
    }

    const buscarPedidos = async ({de, ate, termo, vendedor, status='%'}) => {
        const api = await getApiEmitirNotas();
        
        const result =  await api.get('pedidos/v2', {
            params: {de, ate, termo, vendedor, tipoPedido, status}
        } );
        
        return result.data;   
    }

    const buscaTermosUso = async()=> {
        const api = await getApiEmitirNotas();
        
        const result =  await api.get('pedidos/termos-uso');
        
        return result.data;   
    }

    const removerPedidos = async(ids) => {
        const api = await getApiEmitirNotas();
        
        const result =  await api.delete('pedidos', {
            data: {ids}
        } );
        
        return result.data;   
    }

    const listaStatus = async() => {
        const api = await getApiEmitirNotas();
        
        const result =  await api.get('pedidos/status');
        
        return result.data;   
    }

    return {buscaTermosUso, emitirNFe,removerPedidos, listaStatus, separarEstoque, voltarEstoque, buscaPedido, buscarPedidos, novoPedido, vinculaCliente, vinculaVendedor, desvinculaCliente, desvinculaVendedor, addItemDb, atualizaPedido, removerItemDb, removerServicoDb};
}

export {usePedido};

